import React, { FC } from 'react';
import { Box, Button } from '@mui/material';
import { RiTimeLine, RiSearchLine } from 'react-icons/ri';
import { FilterDropdown } from 'views/rebranded-module/common/components/UI/FilterDropdown';
import StyledBox from 'views/rebranded-module/tours-module/ToursListingViewV2/components/FilterBar/FilterBar.styles';
import { useContent } from 'views/rebranded-module/common/context/useContent';
import { FILTER_TYPES } from 'views/rebranded-module/tours-module/ToursListingViewV2/utils/constants';

const FilterBar: FC<any> = (props) => {
  const {
    flitersList, handleChange, handleSearchBtnClick,
  } = props;
  const cmsData = useContent('ToursListingPage');

  return (
    <StyledBox>
      {flitersList.map((filterList, index) => (
        <FilterDropdown
          key={filterList.type}
          filterList={filterList}
          handleChange={handleChange}
          icon={filterList.type === FILTER_TYPES.DURATION ? <RiTimeLine /> : null}
          isLast={index === flitersList.length - 1}
        />
      ))}

      <Button
        className="FBAction showTABLET"
        variant="contained"
        color="primary"
        onClick={handleSearchBtnClick}
      >
          {cmsData.viewResultsBtnLabel}
      </Button>
    </StyledBox>
  );
};

export { FilterBar };
